import React, { useContext, useState } from 'react';
import styled from 'styled-components';
import ModuleContext from '../../../CMFW/context/ModuleContext';
import { FormControlLabel, Switch } from '@material-ui/core';
import { EditorRow } from '../../../components/common/styles';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import ReadingModel from '../../../models/ReadingModel';
import { IReadingEdit } from '../../../types/reading';
import ReadingTextListText from './ReadingTextListText';
import ReadingTextNew from './ReadingTextNew';

export type IProps = {
  onEditText: (textId: number) => void;
  editingTextId: number;
};

const ReadingTextList: React.FC<IProps> = (props) => {
  const [dnd, setDnd] = useState(false);
  const [editTextId, setEditTextId] = useState(props.editingTextId);
  const module = useContext(ModuleContext) as ReadingModel;
  const item = module.itemUpdated as IReadingEdit;

  const onEditText = (textId: number) => {
    props.onEditText(textId);
    setEditTextId(textId);
  };

  return (
    <Wrapper>
      <DragDropContext onDragEnd={module.onDragEndText.bind(module)}>
        <Droppable isDropDisabled={!dnd} droppableId={'Reading'} direction={'vertical'}>
          {(provided) => (
            <DropWrapper {...provided.droppableProps} ref={provided.innerRef}>
              {item.texts.map((text, index) => (
                <ReadingTextListText
                  text={text}
                  index={index}
                  dnd={dnd}
                  editing={text.id === editTextId}
                  key={`readingText-${text.id}`}
                  onEditText={onEditText}
                />
              ))}
            </DropWrapper>
          )}
        </Droppable>
      </DragDropContext>
      <EditorRow>
        <ReadingTextNew />
        <FormControlLabel
          control={
            <Switch
              checked={dnd}
              onChange={() => setDnd(!dnd)}
              color="primary"
              size="small"
              disabled={item.texts.length < 2}
            />
          }
          label="DND"
        />
      </EditorRow>
    </Wrapper>
  );
};

export default ReadingTextList;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  width: 340px;
`;

const DropWrapper = styled.div`
  height: 100%;
  overflow: auto;
`;
